import axios from "@/http"
export function listCourse(data){
  return axios({
    method:"GET",
    url:"/api/v1/assistant/course/courses",
    params:data
  })
}
export function listCourseAttachment(query) {
  return axios({
    url: '/api/v1/assistant/course/attachments',
    method: 'get',
    params: query
  })
}
export function deleteCourse(id) {
  return axios({
    url: '/api/v1/assistant/course/courses/' + id,
    method: 'delete'
  })
}
export function addCourses(data){
  return axios({
    url: '/api/v1/assistant/course/courses',
    method: 'POST',
    data
  })
}
export function addCourseSegment(data){
  return axios({
    url: '/api/v1/assistant/course/segments',
    method: 'POST',
    data
  })
}
export function getCourses(id){
  return axios({
    url: '/api/v1/assistant/course/courses/'+id,
    method: 'GET',
    params: { preload: true }
  })
}
export function listCourseSegment(query){
  return axios({
    url: '/api/v1/assistant/course/segments',
    method: 'GET',
    params: query
  })
}

export function deleteCourseSegments(query){
  return axios({
    url: '/api/v1/assistant/course/segments',
    method: 'DELETE',
    params: query
  })
}
export function updateCourse(data) {

  return axios({
    url: '/api/v1/assistant/course/courses/'+data.id,
    method: 'put',
    params: data.where?{where: data.where}: undefined,
    data
  })
}


export function fetchAssistantCourseMaterialList(query) {
  return axios({
    url: '/api/v1/assistant/course/materials',
    method: 'get',
    params: query
  })
}

export function fetchAssistantCourseMaterial(id) {
  return axios({
    url: '/api/v1/assistant/course/materials/'+id,
    method: 'get',
    params: { preload: true }
  })
}

export function createAssistantCourseMaterial(data) {
  return axios({
    url: '/api/v1/assistant/course/materials',
    method: 'post',
    data
  })
}

export function updateAssistantCourseMaterial(data) {

  return axios({
    url: '/api/v1/assistant/course/materials/'+data.id,
    method: 'put',
    params: data.where?{where: data.where}: undefined,
    data
  })
}

export function deleteAssistantCourseMaterial(id) {
  return axios({
    url: '/api/v1/assistant/course/materials/' + id,
    method: 'delete'
  })
}

export function deleteAssistantCourseMaterials(query) {
  return axios({
    url: '/api/v1/assistant/course/materials',
    method: 'delete',
    params: query
  })
}


export function listHomeWork(query){
  return axios({
    url: '/api/v1/assistant/course/homeworks',
    method: 'get',
    params: query
  })
}
export function getHomeSubmits(query){
  return axios({
    url: '/api/v1/assistant/course/submits',
    method: 'get',
    params: query
  })
}
export function listCourseSelecter(query){
  return axios({
    url: '/api/v1/assistant/course/relation/courseselects',
    method: 'get',
    params: query
  })
}

export function createAssistantCourseHomework(data) {
  return axios({
    url: '/api/v1/assistant/course/homeworks',
    method: 'post',
    data
  })
}

export function updateAssistantCourseHomework(data) {

  return axios({
    url: '/api/v1/assistant/course/homeworks/'+data.id,
    method: 'put',
    params: data.where?{where: data.where}: undefined,
    data
  })
}
export function createAssistantCourseAttachment(data) {
  return axios({
    url: '/api/v1/assistant/course/attachments',
    method: 'post',
    data
  })
}
export function deleteAssistantCourseAttachment(id) {
  return axios({
    url: '/api/v1/assistant/course/attachments/' + id,
    method: 'delete'
  })
}
export function deleteAssistantCourseHomework(id) {
  return axios({
    url: '/api/v1/assistant/course/homeworks/' + id,
    method: 'delete'
  })
}
export function deleteAssistantCourseAttachments(query) {
  return axios({
    url: '/api/v1/assistant/course/attachments',
    method: 'delete',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/axj-help/axj-help-course.js